import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import {
  ChangableVehicleTemplate,
  VehicleTemplate,
} from "../facades/VehicleTemplate";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";

export const updateVehicleTemplates = (template: VehicleTemplate) => {
  return globalAxiosInstance.put(
    `/vehicles/templates/${template.id}`,
    {
      name: template.name,
      description: template.description,
      all_columns: template.columns.reduce(
        (prev, column) => ({
          ...prev,
          [column.technicalName]: {
            name: column.name,
            has_hover: column.hasHover,
            hover: column.hover,
            default: column.default,
            unit: column.unit,
            scale_factor: column.scale_factor,
            digits_after_comma: column.digits_after_comma,
            values_mapping_name: column.values_mapping_name,
            type: column?.type,
          },
        }),
        {},
      ),
      default_columns: template.columns
        .filter((column) => column.isDefault)
        .map(({ technicalName }) => technicalName),
      ignition_value: template.ignitionValue,
      is_digital: template.columns
        .filter((column) => column.isDigital)
        .map(({ technicalName }) => technicalName),
      tags: template.tags,
      companies: template.companies,
      owner: template.owner,
      display_columns: template.displayColumns,
      is_default_template: template.isDefaultTemplate,
      error_codes_mapping_name: template.errorCodesMappingName || null,
      internal_tariff_id: template.internalTariffId || null,
      odometer_source: template.odometerSource,
    },
    {
      baseURL: process.env.REACT_APP_VEHICLES_API || "",
    },
  );
};

type UpdateVehiclesTemplatesRequest = {
  template: VehicleTemplate;
  updated: ChangableVehicleTemplate;
};

export const useUpdateVehicleTemplates = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: ({ data }) => `/vehicles/templates/${data?.template?.id}`,
  axiosInstance: globalAxiosInstance,
  method: "put",
  buildData: ({ updated, template }: UpdateVehiclesTemplatesRequest) => {
    return {
      ...template.data,
      name: updated.name,
      description: updated.description,
      is_default_template: updated.isDefaultTemplate,
      ignition_value: updated.ignitionValue,
      display_columns: updated.displayColumns,
      all_columns: updated.columns.reduce(
        (prev, column) => ({
          ...prev,
          [column.technicalName]: {
            name: column.name,
            hover: column.hover,
            has_hover: column.hasHover,
            default: column.default,
            unit: column.unit,
            scale_factor: column.scale_factor,
            digits_after_comma: column.digits_after_comma,
            values_mapping_name: column.values_mapping_name,
            type: column?.type,
          },
        }),
        {},
      ),
      companies: updated.companies,
      is_digital: updated.columns
        .filter((column) => column.isDigital)
        .map(({ technicalName }) => technicalName),
      default_columns: updated.columns
        .filter((column) => column.isDefault)
        .map(({ technicalName }) => technicalName),
      tags: updated.tags,
      owner: updated.owner,
      error_codes_mapping_name: updated.errorCodesMappingName || null,
      internal_tariff_id: updated.internalTariffId || null,
      odometer_source: updated.odometerSource,
    };
  },
});
